import React from 'react';

function QuestionOuiNon({ label, value, onChange }) {
    return (
        <div className={"question-group"}>
            <span className={"question-label"}>{label}</span>
            <div className={"btn-oui-non"}>
                <button type={"button"} className={value === true  ? 'active' : ''} onClick={() => onChange(true)}>Oui</button>
                <button type={"button"} className={value === false ? 'active' : ''} onClick={() => onChange(false)}>Non</button>
            </div>
        </div>
    );
}

export { QuestionOuiNon };
